import { AdSizes } from '../Ad/AdSizes';
import Ad from '../Ad/Ad';
import SponsorAd from '../Ad/SponsorAd';

const SearchBannerAd = () => (
	<>
		<Ad
			sizes={{
				'xs sm': AdSizes.MOBILE_LEADERBOARD,
				'md lg': AdSizes.LEADERBOARD,
				'xl xxl': AdSizes.LEADERBOARD_COMBO,
			}}
			htmlId="recipes-leaderboard-ad"
			wrapperClass="recipes-leaderboard-ad leaderboard-ad"
		/>
		<SponsorAd />
	</>
);

SearchBannerAd.propTypes = {};

export default SearchBannerAd;
